import React, {useEffect} from "react";
import {Input} from "reactstrap";
import {formatDate} from "../../script/commFunc";

/**
 *
 * User : 백욱진
 * Date : 2023.05.04
 * @ file : Components/Common/CpmCommYearMonthDay.js
 * @ Desc : 데이트 픽커 컴포넌트(yyyy-MM-DD)
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {string} label - 라벨 명
 * @param {boolean} essential - 필수 여부
 */

const CpmCommYearMonthDay = ({
    id, 
    params, 
    setParams,
    label,
    essential = false,
}) => {
    const paramNm = id || 'yearMonthDay'
    const paramsFormat = "yyMMDD";
    const localFormat = "yyyy-MM-DD";
    const today = formatDate(new Date(), paramsFormat);

    // 날짜 부모 params에 세팅
    const onChangeYearMonthDay = (e) => {
        setParams({[paramNm]: formatDate(e.target.value, paramsFormat)});
    };

    useEffect(() => {
        // 부모 params 초기값 세팅 
        setParams({[paramNm]: params[paramNm] || today});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Input
                id={id}
                name={label || paramNm}
                type="date"
                className={`${essential && 'essential'} form-control`}
                bsSize="sm"
                value={formatDate(params[paramNm], localFormat)}
                max='9999-12-31'
                onChange={onChangeYearMonthDay}
            />
        </>
    );
};

export default CpmCommYearMonthDay;
